import { toastMsg } from "../../utilities/helpers/ToastHelper";
import { storageService } from "../../utilities/service/StorageService";
import { supabase } from "../../utilities/service/SupabaseConnector";

class UserService{
    async updatingUser(userData:any){
        const {data :{user}, error} = await supabase.auth.getUser();
        if(!error && user){
            const response = await supabase
                .from('users')
                .update(userData)
                .eq('id', user?.id)
            return response;
        }
    }
    async gettingUser(){
        const {data :{user}, error} = await supabase.auth.getUser();
        if(!error){
            const response = await supabase
                .from('users')
                .select('*')
                .eq('id', user?.id)
                .single()
            return response;
        }
    }
}
export const userService = new UserService();